import { useState } from "react";

export enum PremiumPubPage {
  INFO = "INFO",
  LOCATION = "LOCATION",
  EVENT = "EVENT",
  REVIEW = "REVIEW",
  RESTAURANT = "RESTAURANT",
}

export const usePubTab = () => {
  // 상단 탭
  const [pubPage, setPubPage] = useState(PremiumPubPage.INFO);
  const isPubPage = (tab: PremiumPubPage) => pubPage === tab;

  return {
    pubPage,
    setPubPage,
    isPubPage,
  };
};
